import React from 'react'
import styled from 'styled-components'

export const ProgressBar = ({ percentage, color }: { percentage: number; color: string }) => {
  return (
    <ProgressBarContainer>
      <ProgressBarBar width={`${Math.round(percentage)}%`} color={color} />
    </ProgressBarContainer>
  )
}

const ProgressBarContainer = styled.div`
  width: 100%;
  height: 10px;
  background-color: #6a6a6a;
  border-radius: 5px;
`

const ProgressBarBar = styled.div<{ width: string; color: string }>`
  height: 100%;
  background-color: ${({ color }) => color};
  border-radius: 5px;
  width: ${({ width }) => width};
`
